import LibraryBookVersionForm from './library-book-version-form';

export default LibraryBookVersionForm;
